import React from 'react';
import { StyleSheet } from 'react-native';
import { EmphasizedSubText, Button } from 'trpc-react-native-ui';

import theme from '../../../../theme-config';

export default class extends React.Component {
  styles = getStyles();

  openConditionsHTML = () => window.open('assets/' + this.props.modalHtmlFile, '_blank');

  render() {
    const styles = this.styles;
    return (
      <Button style={styles.PDPALabelContainer} onPress={this.openConditionsHTML}>
        <EmphasizedSubText style={styles.PDPALabel} emphStyle={styles.PDPALabelEmph} text={this.props.agreementText} />
      </Button>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    PDPALabelContainer: {
      marginVertical: 10,
    },
    PDPALabelEmph: {
      color: theme.signUpPDPALinkColor,
      textDecorationLine: 'underline',
    },
    PDPALabel: {
      color: theme.signUpDarkTextColor,
      fontSize: 15,
    },
  });
